const LeftSideBar = () => {
  return <div className="w-[270px] h-screen mt-[50px] ml-0 bg-primary"></div>;
};
export default LeftSideBar;
